import React from 'react'
import Index from '../_components/Brand/Index'


 const Brand = () => {
  return (
    <Index />
  )
}

export default Brand






